export const data = {
  isSmallDevice: 600,
  LineaRepuestos: "RP",
  Linea2R: "2R",
  Linea3R: "3R",
  PerfilLinea: {
    Repuestos: "Repuestos",
    Vehiculo2R: "Vehiculo2R",
    Vehiculo3R: "Vehiculo3R",
  },
  // EDispositivo: 'DEV',
  MensajeSinProducto:
    "Usted no cuenta con productos en su carrito. Esto ocurrió porque: alguien eliminó el o los productos; o finalizó el pedido; o guardaron el pedido como un Pre-Pedido",
  EDispositivo: "",
  enviroment: "DEV",
  PreguntasFrecuentes: 1,
  Incidentes: 2,
  PageSize: 4,
  PageSizeVehiculos: 12,
  BuscadorCodigoLongitud: 5,
  PageSizeOfertaCarrito: 5,
  PageSizePedidoSugerido: 5,
  PageSizePedidoSugeridoMax: 100,
  PageSizeOfertas: 12,
  PageSizeToAlerta: 2,
  PageSizeAlerta: 10,
  PageSizeRepuestos: 12,
  PageSizeBuscadorCodigo: 12,
  PageSizeFavorito: 12,
  PageSizePaginator: 10,
  Sistema: "WEB",
  PrecioOfe: "P_OFE",
  PrecioFin: "P_FIN",
  PrecioPub: "P_PUB",
  MedioPago: {
    Deposito: 1,
    PrePedido: 2,
  },
  FiltroPedito: {
    ComboAnio: 1,
    ComboModelo: 2,
    ComboVehiculo: 3,
  },
  Pantalla: {
    Dashboard: {
      Ofertas: "Dashboard.Ofertas",
    },
    BuscarPedidoCodigo: {
      Producto: "BuscarPedidoCodigo.Resultado",
      Destacado: "BuscarPedidoCodigo.Destacado",
      Vendido: "BuscarPedidoCodigo.Vendido",
      Reemplazo: "BuscarPedidoCodigo.Reemplazo",
      Etiqueta: {
        GenerarPedido: "Generar Pedido",
      },
    },
    BuscarPedidoVehiculo: {
      Producto: "BuscarPedidoVehiculo.Resultado",
      Repuesto: "BuscarPedidoVehiculo.Repuesto",
      Destacado: "BuscarPedidoVehiculo.Destacado",
    },
    BuscarMasivo: {
      Producto: "BuscarMasivo.Resultado",
    },
    Favoritos: {
      Producto: "Favoritos.Resultado",
    },
    HistorialPedido: {
      Traking: "HistorialPedido.Traking",
      Detalle: "HistorialPedido.Detalle",
    },
    General: {
      PedidoSugerido: "General.PedidoSugerido",
    },
    Catalogo: {
      Ofertas: "Catalogo.Ofertas",
      ProductosVendidos: "Catalogo.ProductosVendidos",
    },
    Carrito: {
      Ofertas: "Carrito.Ofertas",
      Sustituto: "Carrito.Sustituto",
      Producto: "Carrito.Producto",
      PedidoFinalizado: "Carrito.PedidoFinalizado",
      Etiqueta: {
        Ofertas: "Ofertas",
      },
    },
  },
  screen: {
    Login: "Login",
    Header: "Header",
    Drawer: "Drawer",
    Dashboard: "Dashboard",
    Notificaciones: "Notificaciones",
    PedidoMasivo: "PedidoMasivo",
    GenerarPedido: "GenerarPedido",
    Carrito: "Carrito",
    Perfil: "Perfil",
    HistorialPedidos: "HistorialPedidos",
    Bonificacion: "Bonificacion",
    Ayuda: "Ayuda",
  },
  EstadoPedido: {
    Anulado: "ANULA",
    EnPreparacion: "ENPRE",
    Entregado: "ENTRE",
    Expirado: "EXPIR",
    Pagado: "PAGAD",
    PorPagar: "PORPA",
    Procesado: "PROCE",
    Facturado: "FACTU",
    Despachado: "DESPA",
    Todos: "0",
  },
  EstadoCuenta: {
    DocumentoPendientePago: "DPP",
    DepositoPendienteAplicar: "DPA",
    FacturaAnticipo: "FDA",
  },
};
